import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { config } from "config/environment";
import { Md5 } from "ts-md5/dist/md5";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

declare let window: Window & { _sift };

@UntilDestroy()
@Injectable({
	providedIn: "root"
})
export class SiftScienceService {
	public constructor(private router: Router) {}

	public onLogin(sessionId): void {
		if (config.executeSift) {
			try {
				const _sift = window._sift;

				if (_sift) {
					_sift.push(["_setAccount", config.siftScienceAPIKey]);
					_sift.push(["_setUserId", ""]);
					_sift.push(["_setSessionId", Md5.hashStr(sessionId)]);
					_sift.push(["_trackPageview"]);

					this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
						if (event instanceof NavigationEnd) {
							_sift.push(["_trackPageview"]);
						}
					});
				}
			} catch (e) {
				console.error("SiftScienceService onLogin error:", e);
				return;
			}
		}
	}
}
